import { gql } from '@apollo/client';
import SeoTaxonomyFragment from '../Seo/Fragments/SeoTaxonomyFragment';

// eslint-disable-next-line import/prefer-default-export
export const TAG_PAGES_QUERY = gql`
query TagPages(
		$tags: String,
		$postTypes: String,
		$excludePosts: String,
		$paged: Int,
		$limit: Int,
		$meal: String,
		$season: String,
		$dishType: String,
		$specialDiet: String,
		$cookingMethod: String,
		$cuisine: String,
		$occasion: String,
		$excludeUS: Boolean,
	) {
	tagPages(
		tags: $tags,
		postTypes: $postTypes,
		excludePosts: $excludePosts,
		paged: $paged,
		limit: $limit
		meal: $meal,
		season: $season,
		dishType: $dishType,
		specialDiet: $specialDiet,
		cookingMethod: $cookingMethod,
		cuisine: $cuisine,
		occasion: $occasion,
		excludeUS: $excludeUS,
	) {
		found_posts
		max_num_pages
		limit
		paged
		posts {
			postId
			date
			slug
			permalink
			postType
			is_video
			title
			featuredTag {
				name
				uri
			}
			featuredImage
			featuredImageAlt
			serving
			recipetime
			reciperating
			author
			authors {
				title
				permalink
			}
		}
	}
	tags(where: { slug: [$tags] }) {
		nodes {
			id
			databaseId
			name
			description
			uri
			slug
			showTag {
				showTag
			}
			seo {
				...SeoTaxonomyFragment
			}
			distributions
		}
	}
}
${SeoTaxonomyFragment}
`;
